export const filesWuxal = [
    'Wuxal Р Мах',
    'Wuxal Universal Active',
    'Wuxal MacroMix',
    'Wuxal Boron pH',
    'Wuxal Oilseed PLUS',
    'Wuxal CalciBor',
];

export const filesUniferX = ['UniferX +Cu', 'UniferX +Mn', 'UniferX +Zn'];
